import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Injectable()
export class ApiConfig {

    public url = environment.urlApi;

    public urlPortalPagos = environment.urlPortalPagos;

    public urlAccessMP = environment.urlManagement;

    public urlGenerarFacturaPDF = environment.urlGenerarFacturaPDF;

}


// WEBPACK FOOTER //
// /app/src/app/shared/services/config/api.config.ts